export default __webpack_public_path__ + "static/gnosis@2x-a4ad98ea4a1bb00244e07ac6190ffbf1.png";